import { ADD_JSON_LD_ARTICLE, ADD_JSON_LD_BREAD_CRUMB_LIST, ADD_JSON_LD_FAQ, ADD_JSON_LD_LOCAL_BUSINESS, RESET_JSON_LD, } from '../actions/JsonLdActions';
import { initialDataOfLocalBusiness, initialDataOfBreadcrumbList, initialDataOfArticle, initialDataOfFaq, initialDataOfOrganization, } from '../define/consts/jsonld';
const initialState = {
    article: {
        data: initialDataOfArticle,
        isShow: false,
    },
    breadcrumbList: {
        data: initialDataOfBreadcrumbList,
        isShow: false,
    },
    faq: {
        data: initialDataOfFaq,
        isShow: false,
    },
    localBusiness: {
        data: initialDataOfLocalBusiness,
        isShow: false,
    },
    organization: {
        data: initialDataOfOrganization,
        isShow: true,
    },
};
// eslint-disable-next-line default-param-last
export default (state = initialState, { payload, type }) => {
    switch (type) {
        case RESET_JSON_LD: {
            return Object.assign(Object.assign({}, state), initialState);
        }
        case ADD_JSON_LD_ARTICLE: {
            return Object.assign(Object.assign({}, state), { newsArticle: {
                    data: Object.assign(Object.assign({}, state.article.data), { author: payload.author, datePublished: payload.datePublished, headline: payload.headline, image: payload.image, mainEntityOfPage: payload.mainEntityOfPage }),
                    isShow: true,
                } });
        }
        case ADD_JSON_LD_LOCAL_BUSINESS: {
            return Object.assign(Object.assign({}, state), { localBusiness: Object.assign(Object.assign({}, state.localBusiness), { isShow: true }) });
        }
        case ADD_JSON_LD_BREAD_CRUMB_LIST: {
            return Object.assign(Object.assign({}, state), { breadcrumbList: {
                    data: Object.assign(Object.assign({}, state.breadcrumbList.data), { itemListElement: payload.itemListElement }),
                    isShow: true,
                } });
        }
        case ADD_JSON_LD_FAQ: {
            return Object.assign(Object.assign({}, state), { faq: {
                    data: Object.assign(Object.assign({}, state.faq.data), { mainEntity: payload.mainEntity }),
                    isShow: true,
                } });
        }
        default: {
            return state;
        }
    }
};
